export default {
  title: 'Credenziali personale',
  form: {
    username: {
      label: 'Nome utente',
      placeholder: 'Nome utente',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
    },
    button: {
      title: 'Salva',
    },
    success: 'Informazioni salvate con successo.',
  },
};
